import React from 'react';
import propTypes from 'prop-types'
import './Nav.css'
import { Link } from 'react-router-dom';
export default function Navbar(props) {
    const show1 = ()=>{
        document.body.style.backgroundImage = "radial-gradient(circle, #f05930, #ec4b25, #e93c1a, #e5280d, #e10000)";
    }
    const show2 = ()=>{
        document.body.style.backgroundImage = "radial-gradient(circle, #e35151, #f23c6c, #f8288f, #f128b9, #d840e7)";
    }
    const show3 = ()=>{
        document.body.style.backgroundImage = " radial-gradient(circle, #782b83, #4c66c2, #0098e6, #00c4ed, #28ebe2)";
    }
    return (
        <div>
            <nav className={`navbar sticky-top navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/">{props.title}</Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link active" aria-current="page" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/about">About</Link>
                            </li>
                        </ul>
                        <div>
                            <img src="https://th.bing.com/th/id/OIP.gzT7EzQdP7IdvAuN3bh-XwHaHa?w=185&h=185&c=7&r=0&o=5&pid=1.7" className="rounded-circle mx-3 mb-2 mt-1" alt="..." onClick={show1}></img>
                            <img src="https://images.unsplash.com/photo-1557682224-5b8590cd9ec5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTd8fGNvbG9yJTIwYmFja2dyb3VuZHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60" className="rounded-circle mx-3 mb-2 mt-1" alt="..." onClick={show2}></img>
                            <img src="https://images.unsplash.com/photo-1620202431267-bfd880f19cec?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTV8fGNvbG9yJTIwYmFja2dyb3VuZHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60" className="rounded-circle mx-3 mb-2 mt-1" alt="..." onClick={show3}></img>
                        </div>
                        <div className={`form-check form-switch text-${props.mode === 'light' ? 'dark' : 'light'}`}>
                            <input className="form-check-input" type="checkbox" onClick={props.toogleMode} id="flexSwitchCheckDefault" />
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">{`Enable ${props.mode === 'light' ? 'dark' : 'light'} Mode`}</label>
                        </div>
                    </div>
                </div>
            </nav>
        </div >
    )
}

Navbar.propTypes = {
    title: propTypes.string
}

Navbar.defaultProps = {//this is used for setting up default props 
    title: 'userutils'
}